export * from './cnpj'
export * from './email'
export * from './idade'
export * from './ip'